// extracted by mini-css-extract-plugin
export var arrow = "_cq-1";
export var content = "_cq-0";
export var highlighted = "_cq-2";